import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ConfigService } from '../../../../config';
import * as _ from 'lodash';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
    const config = inject(ConfigService);
    if (_.startsWith(req.url, config.mapApiBaseUrl)) {
        return next(req.clone({
            setHeaders: { 'content-type': 'application/json' }
        }));
    }
    return next(req);
};
